import { render, staticRenderFns } from "./StudentRules.vue?vue&type=template&id=790a5056&scoped=true&lang=pug"
import script from "./StudentRules.vue?vue&type=script&lang=js"
export * from "./StudentRules.vue?vue&type=script&lang=js"
import style0 from "./StudentRules.vue?vue&type=style&index=0&id=790a5056&prod&lang=scss"
import style1 from "./StudentRules.vue?vue&type=style&index=1&id=790a5056&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790a5056",
  null
  
)

export default component.exports